// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import RegistrationHistory from '@deere/cps-it.warranty-model-factory/lib/registration-history';
import RegistrationHistoryItem from './registration-history-item';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const RegistrationHistoryList = props =>
    <div>
        {props.registrationHistory.map((registration, index) =>
            <RegistrationHistoryItem
                actions={props.actions}
                isRegistrationFormNotAllowed={props.isRegistrationFormNotAllowed}
                key={index}
                language={props.language}
                registration={registration}
                registrationCount={index}
                security={props.security}
                user={props.user}
            />
        )}
    </div>;

RegistrationHistoryList.displayName = 'RegistrationHistoryList';
RegistrationHistoryList.propTypes = {
    actions: PropTypes.object.isRequired,
    isRegistrationFormNotAllowed: PropTypes.bool.isRequired,
    language: PropTypes.string.isRequired,
    registrationHistory: PropTypes.arrayOf(PropTypes.instanceOf(RegistrationHistory)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default RegistrationHistoryList;



// WEBPACK FOOTER //
// ./src/product/details/components/registration-history-list.js